import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import SEOContent from './components/SEOContent';
import { generateOrganizationSchema, generateWebSiteSchema, generateWebPageSchema } from '@/utils/seo';

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  const orgSchema = generateOrganizationSchema();
  const siteSchema = generateWebSiteSchema();
  const pageSchema = generateWebPageSchema(
    '韩国漫画网 - 韩漫画免费网站,漫画大全,韩漫完整在线观看',
    '韩国漫画网作为免费漫画平台，提供完整的韩漫大全市集与无缝在线观看服务。',
    'https://www.example.com/'
  );

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }} />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryGrid />
        <HotRecommend />
        <LatestUpdate />
        <SEOContent />
      </main>
      <Footer />
    </div>
  );
}